<vee-dialog key="languageSelectDialog">
  <ng-container dialog-title>
    <h2 class="tw:mb-[32px]">
      {{ "FINDER.LIFE_SITUATION.INCLUDED_LANGUAGES.QUESTION" | translate }}
    </h2>
  </ng-container>
  <ng-container dialog-content>
    <vee-language-select
      [(ngModel)]="selectedLanguage"
      (change)="onChangeLanguage($event)"
    ></vee-language-select>
  </ng-container>
  <ng-container dialog-actions>
    <div class="tw:flex tw:gap-16">
      <button
        vee-btn="filled"
        (click)="dialogService.close('languageSelectDialog')"
      >
        {{ "RESULTS.SHARING_VIEW.CLOSE" | translate }}
      </button>
    </div>
  </ng-container>
</vee-dialog>
